import{jsxs as r,jsx as e}from"react/jsx-runtime";import o from"styled-components";import{Spinner as t}from"../../spinner/Spinner.js";import{BodySecondary as n}from"../../TypographyStyle.js";import{COLORS as s}from"../../../constants/Theme.js";const i=o.div`
	width: 200px;
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 4px 8px;
	width: 200px;
	background: ${s.surface.hovered};
	border: 1px solid ${s.stroke.primary};
	border-radius: 4px;
`,l=o=>{let{containerStyle:l}=o;return r(i,Object.assign({style:Object.assign({},null!=l?l:{})},{children:[e(n,Object.assign({style:{color:s.content.secondary,flex:1}},{children:"Loading..."})),e(t,{size:"small",color:s.stroke.brand})]}))};export{l as default};
